<template>
  <div>
    <div class="mb-6">
      <div class="location-home pt-2.5">
        <!-- <h3 class="fsize20 font-semibold">Home / {{ get_location }}</h3> -->
        <h4 class="fsize30 text-primary font-semibold" v-if="!cardView">
          {{ this.serviceName }}
        </h4>
        <h3 class="fsize30 font-semibold text-primary mb-4" v-if="cardView">
          Service Provider
        </h3>
      </div>

      <div class="flex ml-auto lg:mt-0 md:mt-0 mt-4">
        <!-- <b-form-input
          id="input-default"
          label-size="large"
          class=""
        ></b-form-input> -->

        <div class="search">
          <base-button
            @click="handleRoute('request-form', 'request-for-service')"
            type="primary"
            class="search-clr-btn ml-2"
            ><span> Request for Service </span>
            <!-- <span v-if="cardView"> About Service </span> -->
          </base-button>
          <base-button
            @click="handleService"
            type="primary"
            class="search-clr-btn ml-2"
          >
            <span> Know Your Service Provider </span>
          </base-button>
        </div>
      </div>
    </div>
    <div class="" v-show="!cardView">
      <!-- <img
        src="../../../assets/images/nodata.svg"
        alt="image"
        class="sprovider-img mx-auto"
      /> -->

      <p>
        <span class="font-bold text-primary"> Service Description:</span>
        Making a will and planning for inheritance can be a challenging
        conversation within Indian families. However, it's a crucial discussion
        to ensure that family wealth is distributed to the right legal heirs,
        avoiding complications and disputes.
      </p>
      <br />

      <div class="text-777777 font-normal mb-2">
        <span class="font-bold text-primary">
          Why Consider Will and Inheritance Planning:
        </span>
        Planning your will and inheritance matters offers several important
        benefits:
      </div>
      <ul class="list-decimal font-bold mb-4">
        <li class="text-777777 font-normal">
          <span class="font-bold text-primary"> Legal Clarity: </span>
          Creating a will ensures that your wishes regarding your assets are
          legally documented and clear.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary">Avoiding Family Disputes: </span>
          A well-structured will minimizes the chances of disputes among family
          members, providing peace of mind.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary">Asset Protection: </span>
          Protect your hard-earned assets and ensure they are utilized according
          to your preferences.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary">Supporting Loved Ones: </span>
          Secure the financial future of your loved ones by specifying how your
          assets should be distributed.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary">Tax Efficiency:</span>
          Proper planning can help minimize tax liabilities, ensuring your heirs
          receive a larger share.
        </li>
      </ul>

      <p>
        <span class="text-primary font-bold"> Our Service:</span> We understand
        the sensitivity of will and inheritance planning, and we are here to
        assist you. Caregiver Saathi connects you with experienced legal experts
        who specialize in this area. These professionals provide invaluable
        guidance and support to ensure that your legacy is protected and
        distributed as per your wishes.
        <br />
      </p>

      <h6 class="mt-4 text-primary fsize16 font-bold">Why Choose Us:</h6>
      <ul class="list-decimal font-bold mb-4">
        <li class="text-777777 font-normal">Access to trusted legal experts</li>

        <li class="text-777777 font-normal">
          Peace of mind knowing your wishes will be honored
        </li>

        <li class="text-777777 font-normal">Minimize family disputes</li>
        <li class="text-777777 font-normal">
          Strengthen your emotional well-being.
        </li>
        <li class="text-777777 font-normal">
          Protect your assets and loved ones
        </li>
      </ul>
      <p class="mb-2">Take Control of Your Legacy Today!</p>
    </div>
    <Bcard class="lg:mt-20 md:mt-20 mt-12" v-show="cardView" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Bcard from "./Bcard.vue";

export default {
  props: ["location"],
  components: {
    Bcard,
  },
  data() {
    return {
      dataFound: false,
      serviceName: "",
      cardView: false,
    };
  },
  computed: {
    ...mapState("respitecare", {
      get_location: "get_location",
    }),
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
    }),
    ...mapState("auth", ["user"]),
  },
  methods: {
    handleRoute(name, params) {
      // if (Object.keys(this.user).length === 0) {
      //   this.$router.push({ name: "signin" });
      //   this.$swal.fire({
      //     title: "",
      //     text: "Please login to access this content",
      //     icon: "warning",
      //     confirmButtonColor: "#830c81",
      //     showCancelButton: false,
      //   });
      //   return;
      // }
      this.$router.push({ name: name, params: { pathName: params } });
    },
    async handleService() {
      if (Object.keys(this.user).length === 0) {
        this.$router.push({ name: "signin" });
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.userDetails = sessionStorage.getItem("token");
      try {
        // if (this.userDetails === null) {
        //   this.$swal
        //     .fire({
        //       title: "Login!",
        //       text: "Please login to continue",
        //       icon: "info",
        //       confirmButtonText: "Okay",
        //       confirmButtonColor: "#830c81",
        //       showCancelButton: false,
        //     })
        //     .then((result) => {
        //       return this.$router.push({ name: "signin" });
        //     });
        //   return;
        // }
        this.cardView = !this.cardView;
        let payload = {
          service: this.serviceName,
        };
        let data = await this.$store.dispatch(
          "respitecare/getVolunteerByService",
          payload
        );
      } catch (error) {
        console.log(error);
      }

      // this.$router.push({ name: 'product-services',query:{scroll:true} });
      // let urlToRedirect = `${window.location.origin}/product-services`;
      // localStorage.setItem("bookService", true);
      // window.open(urlToRedirect, "_blank");
    },
  },
  mounted() {
    if (this.get_volunteer_by_location.length > 0) {
      this.dataFound = true;
    }
    this.serviceName = this.$route.query.service;
    // console.log(this.serviceName);
  },
};
</script>

<style>
.search-clr-btn {
  color: #f8f9fe;
  background-color: #4f0a4b;
}
.fsize30 {
  font-size: 30px;
}
</style>
